import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"


interface IDetalhePais {

    codigo: number;
    nome: string;
    sigla: string;
    codRegiao: number;
}

interface IListagemPais {
    codigo: number;
    nome: string;
    sigla: string;
    codRegiao: number

}

export interface IDadosRetornoPais {
    dado: IListagemPais[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDadosRetorno {
    dado: IListagemPais[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

type TPaissComTotalCount = {
    data: IDadosRetorno;
    totalCount: number;
}

const getAll = async (page = 1, filter = '', id = 0): Promise<TPaissComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get("/pais/sql", {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: null,
            NumeroPagina: page,
            TamanhoPagina: Enviroment.LIMITE_DE_LINHAS,
            Filtro: null,
            Filtro2: filter
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getById = async (codigo: number): Promise<IDetalhePais> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalhePais>(`/pais/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const Create = async (dados: Omit<IDetalhePais, "codigo">): Promise<number | Error> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post<IDetalhePais>(`/pais`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data.codigo;

}

const updateById = async (codigo: number, dados: IDetalhePais): Promise<void> => {
    const token = CookieService.get("access_token");
    return await Api.put(`/pais/${codigo}`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

}

const deleteById = async (codigo: number): Promise<void | Error> => {

    const token = CookieService.get("access_token");
    return await Api.delete(`/pais/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

}

export const PaisService = {

    getAll,
    getById,
    Create,
    updateById,
    deleteById
}